import { getAnalytics, logEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyARQYhV4oIyhcUuRdRR4aoRrfsxYVjTwOk",
  appId: "1:38598333912:web:37edb29254687fee8acead",
  measurementId: "G-4TXVC7GPEP",
  projectId: "dbtest-25893",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const logAppEvent = (eventName, eventParams) => {
  logEvent(analytics, eventName, eventParams);
};
export { analytics, app, logAppEvent };
